export const URL_API = 'http://192.168.1.45'

export const TOKEN_NAME = 'auth_ic'